export default "__VITE_PUBLIC_ASSET__5c8904ef__"